const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function fetchGeoLocation() {
  try {
    const response = await fetch(
      'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation',
      { headers: { accept: 'text/plain' } }
    );
    const data = await response.json();
    if (data.isSuccess) return data;
    throw new Error('GeoLocation failed');
  } catch {
    try {
      const response = await fetch(`${API}/geolocation`);
      return await response.json();
    } catch {
      return { isSuccess: false, data: null };
    }
  }
}

export async function submitLead(formData) {
  const response = await fetch(`${API}/submit-lead`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });
  const result = await response.json();
  if (response.status === 200 && result.isSuccess && result.data?.customerId) {
    return { success: true, customerId: result.data.customerId };
  }
  if (response.status === 401) {
    throw new Error(result.message || 'Unauthorized request');
  }
  if (response.status === 400) {
    throw new Error(result.errorMessage || 'Invalid input provided');
  }
  throw new Error(result.errorMessage || result.message || 'Something went wrong');
}
